import React, { CSSProperties } from "react";

export default function NotFound() {
  const styles: Record<string, CSSProperties> = {
    container: {
      fontFamily: '"Quicksand", sans-serif',
      backgroundColor: "rgba(26, 26, 26, 0.8)",
      color: "#dac5a7",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      textAlign: "center",
    },
    heading: {
      fontFamily: '"Playfair Display", serif',
      fontSize: "3rem",
      fontWeight: 300,
      marginBottom: "20px",
      letterSpacing: "-0.02em",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
    },
    paragraph: {
      fontSize: "1.2rem",
      marginBottom: "40px",
      lineHeight: 1.6,
    },
    button: {
      backgroundColor: "#dac5a7",
      color: "#1d1e1f",
      border: "none",
      padding: "10px 20px",
      fontSize: "1rem",
      fontWeight: 500,
      borderRadius: "4px",
      cursor: "pointer",
      textTransform: "uppercase" as const,
      letterSpacing: "0.1em",
      transition: "background-color 0.3s ease",
    },
  };

  // For hover effect with proper TypeScript typing
  const handleMouseOver = (e: React.MouseEvent<HTMLButtonElement>) => {
    (e.target as HTMLButtonElement).style.backgroundColor =
      "rgba(218, 197, 167, 0.9)";
  };

  const handleMouseOut = (e: React.MouseEvent<HTMLButtonElement>) => {
    (e.target as HTMLButtonElement).style.backgroundColor = "#dac5a7";
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404 - Page Not Found</h1>
      <p style={styles.paragraph}>
        The page you are looking for does not exist.
      </p>
      <button
        style={styles.button}
        onClick={() => (window.location.href = "/")}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        Return to Home
      </button>
    </div>
  );
}
